import { render, staticRenderFns } from "./UserGroupModal.vue?vue&type=template&id=3b0b3d56"
import script from "./UserGroupModal.vue?vue&type=script&lang=ts"
export * from "./UserGroupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports